import React from 'react';
import { compose, pure } from 'utils/react';
import styles from './Switch.scss';

const Switch = (props) => {
  const handleToggleButtonChange = ({ target }) =>
    props.input.onChange(target.checked);

  return (
    <label className={styles.switch}>
      <input
        {...props.input}
        type="checkbox"
        checked={props.input.value}
        onChange={handleToggleButtonChange}
      />
      <span className={styles.slider} />
    </label>
  );
};

export default compose(pure())(Switch);
